module.exports = __webpack_public_path__ + "static/media/bts2.81c6f567.jpg";